/**
 * Get a cookie value
 *
 * @deprecated use Cookies.getCookie() (typescript) instead
 * @param cname
 * @returns {*}
 */
window.getCookie = function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

/**
 * Set a cookie for a year
 *
 * @deprecated use Cookies.setCookie() (typescript) instead
 * @param name
 * @param value
 * @param expiration
 */
window.setCookie = function setCookie(name, value, expiration) {
    if (!expiration) {
        expiration = new Date();
        expiration.setFullYear(expiration.getFullYear() + 1);
        expiration.toUTCString();
    }

    if (!value) {
        value = true;
    }

    var cookie = name + '=' + value + '; expires=' + expiration + ';path=/';

    if (window.getCookie('punch_out')) {
        cookie += ';SameSite=None;Secure';
    }

    document.cookie = cookie;
}
